
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die grossen Religionen der Achsenzeit haben für diese und weitere Bedrohungen
der menschlichen Sinnsuche stets Trost angeboten: bei unerträglichem Schmerz,
Krankheit, Not, Einsamkeit, Verzweiflung angesichts des bevorstehenden Todes –
laut Habermas haben sie lebensgeschichtliche Unsicherheit über die Jahrhunderte
vergleichsweise erfolgreich bewältigt. Schliesslich konnte und kann jederzeit
alles passieren und damit auch alles Schreckliche. Im besseren Fall hat die
Religion ihr Trostangebot laufend an die wissenschaftlichen Erkenntnisse
angepasst – und blieb nicht zwingend mit einer unhaltbaren Gottes- oder
Himmelsvorstellung über den Wolken verbunden.`}</p>
    <p>{`Das Grundbedürfnis für Trost und Gelassenheit gegenüber den grossen Ängsten der
menschlichen Existenz bleibt. Der protestantische Theologe Paul Tillich nennt in
seiner Existenzphilo­sophie die Angst vor Schicksal und Tod, jene vor
Sinnlosigkeit und Leere und jene vor Schuld und Verdammung. Das aktuelle Revival
der Moral, sichtbar etwa in der dringlichen Aktualität eines neuen Umgangs mit
der Natur, ja selbst die – zeitweilig aus dem Ruder laufenden – Formen
politischer Korrektheit zeigen, wie aktuell die Angst vor Schuld ist.`}</p>
    <p>{`Die klassischen Religionen aus der Achsenzeit eröffneten ihren Gläubigen auch
die Perspektive einer rettenden Gerechtigkeit, wenn oft auch erst nach dem Tod.
Sie trugen damit wesentlich zur sozialen Stabilität der entstehenden
Stadtstaaten bei. Das kann man als negative Befriedung in der Abhängigkeit einer
unterdrückten Klasse deuten, wie es Karl Marx tat, oder auch als positive
Befriedung, weil es Gewaltexzesse wie Blutrache unterband. Peter Sloterdijk
bezeichnet die grossen Religionen in diesem Zusammenhang als Zornbanken, an
deren Schalter man Ressentiments ab- und anlegen konnte mit der Aussicht auf
Zinsen in Form der Weiterexistenz nach dem Tod.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;